import React, { useEffect } from 'react'
import {
  useLocation,
  Route,
  Switch,
  Redirect,
  Prompt,
  useParams,
  useHistory,
} from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { useRoutes } from 'useRoutes.js'
import AdminNavbar from 'components/Navbars/AdminNavbar'
import NewForgotPassword from 'views/pages/Login/forgotPassword'
import Sidebar from 'components/Sidebar/Sidebar.js'
import kiwiLogo from '../assets/img/brand/kiwi-logo.png'
import Login from 'views/pages/Auth/Login'
import ForgotPassword from 'views/pages/Auth/ForgotPassword/ForgotPassword'
import EditCourseGroup from 'views/pages/LearningPlan/CourseGroup/EditCourseGroup'
import NewCourse from 'views/pages/LearningPlan/Course/NewCourse'
import NewCourseGroup from 'views/pages/LearningPlan/CourseGroup/NewCourseGroup'
import EmployeeReport from 'views/pages/EmployeeReport'
import ConfigContainer from 'store/ConfigurationSettings'
import EditCourse from 'views/pages/LearningPlan/Course/EditCourse'
import UserList from 'views/pages/User/UserList'
import UserForm from 'views/pages/User/UserForm'
import SettingsContainer from 'store/location-settings/settings'
import Dashboard from 'views/pages/dashboards/Admin'
import Profile from 'views/pages/Auth/Profile'
import FirstLogin from 'views/pages/Auth/FirstLogin/FirstLogin'
import ConfirmPassword from 'views/pages/Login/confirmPassword'
import { fetchUserPrivileges } from 'store/Users/actions'

import { sidebarStatus } from 'store/user/actions'
import ViewCourse from 'views/pages/LearningPlan/Course/ViewCourse'
import { setIsBlocking } from 'store/ConfigurationSettings/GeneralConfig/actions'
import { CardHeader } from 'reactstrap'
import CardsHeader from 'components/Headers/CardsHeader'
import ResetPassword from 'views/pages/Login/resetPassword'
import { setPathname } from 'store/Dashboard/actions'
import Signup from 'views/pages/Login/signup'
import PublicCatalog from 'views/pages/PublicCatalog'
import TextEditorModal from 'views/pages/dashboards/components/Commboard/TextEditorModal'

function Admin() {
  const dispatch = useDispatch()
  const routes = useRoutes()

  const auth = useSelector((state) => state.auth)
  const [sidenavOpen, setSidenavOpen] = React.useState(true)
  const { theme } = useSelector((state) => state.themeConfig)
  const location = useLocation()
  const mainContentRef = React.useRef(null)
  const language = useSelector((state) => state.language?.language?.data)
  const {
    isFullscreen,
    name: courseName,
    inViewCourse,
  } = useSelector((state) => state.courses)

  const { isBlocking } = useSelector((state) => state.generalConfig)
  const commboard = useSelector((state) => state.commboard)

  React.useEffect(() => {
    const isInIframe = window.self !== window.top
    if (!isInIframe && window.innerWidth < 1200) {
      document.body.classList.remove('g-sidenav-pinned')
      document.body.classList.add('g-sidenav-hidden')
      setSidenavOpen(false)
    }
  }, [])

  React.useEffect(() => {
    document.documentElement.scrollTop = 0
    document.scrollingElement.scrollTop = 0
    mainContentRef.current.scrollTop = 0
    dispatch(setIsBlocking(false))
    // toggleSidenav()
  }, [location])

  // useEffect(() => {
  // 	dispatch(fetchUserPrivileges)
  // }, [dispatch])

  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (!auth.isAuthenticated) {
        if (prop.path === 'forgot-password') {
          return (
            <Route
              path='/auth/forgot-password'
              component={ForgotPassword}
              key={key}
            />
          )
        }
        if (prop.path === 'reset-password') {
          return (
            <Route path='/reset-password' component={ResetPassword} key={key} />
          )
        }
        if (prop.path === 'signup') {
          return <Route path='/auth/signup' component={Signup} key={key} />
        }

        return <Route path='/auth/login' component={Login} key={key} />
      }

      if (prop.collapse) {
        return getRoutes(prop.views)
      }
      if (
        (auth.isAuthenticated ||
          location.pathname.includes('/job/ai-interview')) &&
        prop.layout === ''
      ) {
        return (
          <Route
            path={prop.layout + prop.path}
            component={prop.component}
            key={key}
          />
        )
      } else {
        return null
      }
    })
  }
  const getBrandText = (path) => {
    for (let i = 0; i < routes.length; i++) {
      if (location.pathname.indexOf(routes[i].layout + routes[i].path) !== -1) {
        return routes[i].name
      }
    }
    return 'Brand'
  }
  // toggles collapse between mini sidenav and normal
  // const toggleSidenav = (e) => {
  //   if (document.body.classList.contains('g-sidenav-pinned')) {
  //     document.body.classList.remove('g-sidenav-pinned')
  //     document.body.classList.add('g-sidenav-hidden')
  //   } else {
  //     document.body.classList.add('g-sidenav-pinned')
  //     document.body.classList.remove('g-sidenav-hidden')
  //   }
  //   setSidenavOpen((prevState) => !prevState)
  //   dispatch(
  //     sidebarStatus(document.body.classList.contains('g-sidenav-pinned'))
  //   )
  // }

  const toggleSidenav = (e) => {
    const isDesktop = window.innerWidth >= 1200

    const isPinned = document.body.classList.contains('g-sidenav-pinned')

    if (isPinned) {
      document.body.classList.remove('g-sidenav-pinned')
      document.body.classList.add('g-sidenav-hidden')
    } else {
      document.body.classList.add('g-sidenav-pinned')
      document.body.classList.remove('g-sidenav-hidden')
    }

    // Always keep React state in sync for UI elements (backdrop, sidebar)
    setSidenavOpen((prevState) => !prevState)

    if (isDesktop) {
      // Only trigger layout-affecting updates here
      dispatch(
        sidebarStatus(document.body.classList.contains('g-sidenav-pinned'))
      )
    } else {
      // For mobile, just toggle overlay class (no layout impact)
      document.body.classList.toggle('sidenav-overlay-open')
    }
  }

  const getNavbarTheme = () => {
    return location.pathname.indexOf('admin/alternative-dashboard') === -1
      ? 'dark'
      : 'light'
  }

  return (
    <>
      {inViewCourse ||
      location.pathname.includes('/job/ai-interview') ? null : (
        <Sidebar
          routes={routes}
          toggleSidenav={toggleSidenav}
          sidenavOpen={sidenavOpen}
          logo={{
            innerLink: '/dashboard',
            imgSrc:
              theme.navlogo && theme.navlogo.url ? theme.navlogo.url : kiwiLogo,
            imgAlt: '...',
          }}
        />
      )}

      <div className='main-content' ref={mainContentRef}>
        {!isFullscreen && !location.pathname.includes('/job/ai-interview') && (
          <>
            <AdminNavbar
              theme={getNavbarTheme()}
              toggleSidenav={toggleSidenav}
              sidenavOpen={sidenavOpen}
              brandText={getBrandText(location.pathname)}
              courseName={courseName}
            />
            <CardsHeader />
          </>
        )}
        <Prompt
          when={isBlocking}
          message={'You have unsaved changes, do you want to continue anyway?'}
        />

        <Switch>
          {getRoutes(routes)}
          <Route path='/group/:id/edit' component={EditCourseGroup} />
          <Route path='/group/:id/edit/checklist' component={EditCourseGroup} />
          <Route path='/dashboard' component={Dashboard} />
          <Route path='/first-login' component={FirstLogin} />
          <Route path='/forgot-password' component={NewForgotPassword} />
          <Route path='/signup' component={Signup} />

          <Route path='/reset-password' component={ResetPassword} />
          <Route path='/public-catalog/:id' component={PublicCatalog} />
          <Route path='/job/career/:id' component={PublicCatalog} />

          <Route path='/confirm-password' component={ConfirmPassword} />
          <Route path='/profile' component={Profile} />
          <Route path='/group/new' component={NewCourseGroup} />
          <Route path='/course/new' component={NewCourse} />
          <Route path='/manager-reports/export?role_id' />
          <Route path='/manager-reports/export?token' />
          <Route
            path='/manager-reports/employee/:userId'
            component={EmployeeReport}
          />

          <Route path='/course/:id/edit' component={EditCourse} />
          {/*<Route path="/learning-plan/course/:id/edit" component={EditCourse} />*/}
          <Route path='/course/:id' component={ViewCourse} />
          {/*<Route*/}
          {/*  path="/learning-plan/course/:id"*/}
          {/*  render={(props) => {*/}
          {/*    return <ViewCourse {...props} />;*/}
          {/*  }}*/}
          {/*/>*/}

          <Route
            path='/settings'
            render={(routeProps) => (
              <SettingsContainer {...routeProps} language={language} />
            )}
          />
          <Route path='/config' component={ConfigContainer} />
          <Route exact path='/settings/users' component={UserList} />
          <Route path='/settings/users/:id' component={UserForm} />
          <Redirect
            from='*'
            to={
              auth.isAuthenticated ||
              location.pathname.includes('/job/ai-interview')
                ? '/dashboard'
                : '/auth/login'
            }
          />
          {/* {auth.isAuthenticated ? null : (
						<Redirect from='*' to={'/auth/login'} />
					)} */}
        </Switch>
      </div>
      {sidenavOpen ? (
        <div className='backdrop d-xl-none' onClick={toggleSidenav} />
      ) : null}
      {auth.isAuthenticated ? (
        <TextEditorModal isOpen={commboard.toggleModal} />
      ) : null}
    </>
  )
}

export default Admin
